import React, { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { features } from "@/lib/features";
import Analytics from "@/components/dashboard/Analytics";
import { Button } from "@/components/ui/button";
import AIAgentsSection from "@/components/dashboard/AIAgentsSection";
import { useAuth } from "@/hooks/useAuth";
import { isSessionValid } from "@/lib/auth-utils";
import { setSessionExpiredCallback } from "@/lib/api-client";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { FriendInviteManager } from "@/components/dashboard/FriendInviteManager";
import { EnhancedAIAgentsSection } from "@/components/dashboard/EnhancedAIAgentsSection";
import { EnhancedOverview } from "@/components/dashboard/EnhancedOverview";
import { EnhancedActivity } from "@/components/dashboard/EnhancedActivity";
import { EnhancedAnalytics } from "@/components/dashboard/EnhancedAnalytics";
import { useTrialStatus } from "@/hooks/useTrialStatus";

const Dashboard = () => {
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const trialStatus = useTrialStatus();
  const [sessionCheckCount, setSessionCheckCount] = useState(0);
  
  // Manual session check function for testing
  const handleManualSessionCheck = async () => {
    try {
      const isValid = await isSessionValid();
      if (isValid) {
        setSessionCheckCount((prev) => prev + 1);
      } else {
        console.warn("Session is invalid or expired.");
      }
    } catch (error) {
      console.error("Session check error:", error);
    }
  };

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    setSessionExpiredCallback(() => {});
    handleManualSessionCheck();

    return () => {
      setSessionExpiredCallback(() => {});
    };
  }, [user, navigate]);

  const hasSystemAccess = () => {
    return profile?.role === "admin" || profile?.role === "lawyer";
  };

  return (
    <div className="space-y-4">
      <Tabs
        defaultValue="overview"
        className="space-y-4"
        key={`${profile?.role || "loading"}`}>
        <TabsList>
          <TabsTrigger value="overview">Resumen</TabsTrigger>
          <TabsTrigger value="features">Funciones</TabsTrigger>
          {profile && profile.role === "admin" && (
            <TabsTrigger value="friends">Invitar Amigos</TabsTrigger>
          )}
          {/* <TabsTrigger value="agents">Agentes IA</TabsTrigger> */}
          {/* <TabsTrigger value="activity">Actividad</TabsTrigger> */}
          {profile && profile.role === "admin" && (
            <TabsTrigger value="analytics">Análisis</TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="overview" className="space-y-4">
          <EnhancedOverview />
        </TabsContent>

        <TabsContent value="features" className="space-y-4">
          <EnhancedAIAgentsSection />
        </TabsContent>

        {profile && profile.role === "admin" && (
          <TabsContent value="friends">
            <FriendInviteManager />
          </TabsContent>
        )}

        <TabsContent value="agents" className="space-y-4">
          <AIAgentsSection />
        </TabsContent>

        {/* <TabsContent value="activity" className="space-y-4">
          <EnhancedActivity />
        </TabsContent> */}

        {profile && profile.role === "admin" && (
          <TabsContent value="analytics">
            <EnhancedAnalytics />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default Dashboard;
